import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  setHeroBannerPromosAndEvents,
  setHeroBanners,
  setFeatured,
  setPromos,
  setEvents,
  setMerchants,
  setMalls,
  setCMSMalls,
  setMarketingContentModalData,
  setMarketingContentModalStatus,
  setMerchantsListModalData,
  setStoreModalData,
  setCurrentMallInModal,
  setOurMallModalStatus,
  setCardListModalData,
  setCardListModalStatus,
} from '../../../modules/dashboard/actions/creators'

import { setPrimaryInfo } from '../../../modules/profile/actions/creators'

import {
  setAccessToken,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import {
  setLoyaltyPoints,
  setTransactionsEarned,
  setTransactionsRedeemed,
} from '../../../modules/loyalty/actions/creators'

import { setError, removeError } from '../../../modules/errors/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

import {
  doGetRelatedArticles,
  doGetMarketingContent,
  doGetBestDeals,
  doGetWhatsOn,
  doGetFeaturedMarketingContent,
} from '../../../controllers/MarketingContent'

import { doGetDashboardHeroBannerPromosAndEvents } from '../../../controllers/Dashboard'

const mapStateToProps = reduxState => {
  const {
    dashboard,
    auth,
    profile,
    loyalty,
    errors,
    // , explore
  } = reduxState
  const { accessToken, firebaseMessagingToken } = auth
  const { primaryInfo, registrationToken } = profile
  const {
    heroBanner,
    heroBannerPromosAndEvents,
    heroBanners,
    featured,
    promos,
    events,
    merchants,
    malls,
    cmsMalls,
    showMarketingContentModal,
    marketingContentModalData,
    marketingContentModalStatus,
    showMerchantsListModal,
    merchantsListModalData,
    cardListModalData,
    showCardListModal,
    cardListModalStatus,
    showStoreModal,
    storeModalData,
    currentMallInModal,
    showOurMallModal,
    ourMallModalStatus,
  } = dashboard
  const { loyaltyPoints, transactionsEarned, transactionsRedeemed } = loyalty
  const { errorList } = errors

  return {
    heroBanner,
    heroBannerPromosAndEvents,
    heroBanners,
    featured,
    promos,
    events,
    merchants,
    malls,
    cmsMalls,
    primaryInfo,
    registrationToken,
    accessToken,
    showMarketingContentModal,
    marketingContentModalData,
    marketingContentModalStatus,
    showMerchantsListModal,
    merchantsListModalData,
    cardListModalData,
    showCardListModal,
    cardListModalStatus,
    showStoreModal,
    storeModalData,
    loyaltyPoints,
    transactionsEarned,
    transactionsRedeemed,
    currentMallInModal,
    showOurMallModal,
    ourMallModalStatus,
    errorList,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
    doGetRelatedArticles,
    doGetMarketingContent,
    doGetBestDeals,
    doGetWhatsOn,
    doGetFeaturedMarketingContent,
    doGetDashboardHeroBannerPromosAndEvents,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLoyaltyPoints,
      setTransactionsEarned,
      setTransactionsRedeemed,
      setHeroBannerPromosAndEvents,
      setHeroBanners,
      setFeatured,
      setPromos,
      setEvents,
      setMerchants,
      setPrimaryInfo,
      setMalls,
      setCMSMalls,
      push,
      setAccessToken,
      setMarketingContentModalData,
      setMarketingContentModalStatus,
      setMerchantsListModalData,
      setStoreModalData,
      setCurrentMallInModal,
      setOurMallModalStatus,
      setCardListModalData,
      setCardListModalStatus,
      waitRenderServer,
      renderServer,
      setError,
      removeError,
      setFirebaseMessagingToken,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
